import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { controlsCategory } from "../../../../scenes/stack/environment/icons/iconExport";

const ControlCategoryFilter = ({ selected, label, handleChange }) => {
  const colors = useColors();
  const icon = controlsCategory[label];
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap={2}
      sx={{
        width: "170px",
        height: "56px",
        borderRadius: "8px",
        padding: "12px",
        cursor: "pointer",
        boxShadow: selected
          ? "0 0 4px 1px " + colors.primary_150 + " inset"
          : "0 0 4px 0 " + colors.primary_48percent,
        "&:hover": {
          boxShadow: "0 0 4px 1px " + colors.primary_50,
        },
      }}
      onClick={() => {
        handleChange(label, !selected);
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        gap={1}
        sx={{
          width: "32px",
          height: "32px",
          backgroundColor: colors.primary_8percent,
          color: colors.primary_300,
          borderRadius: "4px",
          boxShadow: "0 0 4px 0 " + colors.primary_48percent,
        }}
      >
        <SvgToIcon IconLogo={icon} width={"24px"} />
      </Box>
      <Typography variant="subtitle2">{label}</Typography>
    </Box>
  );
};

export default ControlCategoryFilter;
